import { getEnvConfig } from "../../config/envConfig"

export const styles = theme => ({
  containerStyle: {
    width: "100%",
    minHeight: "100vh",
    padding: "110px 0 64px 0",
    position: "relative",
    background: theme.palette.background.default,

    "&:before": {
      content: "''",
      width: "100%",
      height: "300px",
      background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.light})`,
      position: "absolute",
      left: "0",
      top: "0",
      zIndex: "0"
    },

    "&:after": {
      content: "''",
      width: "120px",
      minHeight: "80px",
      background: `url('${getEnvConfig("light")?.logoDark}')`,
      backgroundPosition: "0 0",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      position: "absolute",
      left: "20px",
      top: "20px",
      zIndex: "1"
    },

    "@media screen and (max-width: 768px)": {
      padding: "64px 20px"
    }
  },

  centerStyle: {
    maxWidth: "900px",
    width: "100%",
    background: theme.palette.background.paper,
    border: `1px solid ${theme.utils.setTransparency(
      theme.palette.text.primary,
      0.1
    )}`,
    height: "auto",
    borderRadius: theme.shape.borderRadius,
    padding: "20px 16px",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "36px auto 0 auto",

    "@media screen and (min-width: 768px)": {
      margin: "0 auto",
      padding: "48px 36px",
      width: "80%"
    }
  },

  titleStyle: {
    textAlign: "center",
    fontSize: 20,
    color: theme.palette.text.primary,
    fontWeight: 500,
    margin: "8px 0 0 0",

    "@media screen and (min-width: 768px)": {
      fontSize: 28
    }
  },

  subtitleStyle: {
    maxWidth: "90%",
    color: theme.palette.text.secondary,
    fontSize: 16,
    textAlign: "center",
    margin: "16px auto 0 auto",

    "@media screen and (min-width: 768px)": {
      maxWidth: "60%",
      fontSize: 18
    }
  },

  buttonStyle: {
    background: theme.palette.primary.main,
    transition: "0.3s",
    margin: "36px 0 0 0",

    "&:hover": {
      background: theme.palette.primary.light
    },

    "@media screen and (min-width: 768px)": {
      margin: "48px 0 0 0"
    }
  },

  imgStyle: {
    maxWidth: "300px",
    width: "90%",
    height: "auto",
    objectFit: "contain"
  }
})
